import { flow } from 'fp-ts/function';
import { filter, sortBy } from 'lodash/fp';
import { OccupancyData } from '../modules/resourceOrder/occupancyTypes';

export const sortOccupancyData = flow(
    filter<OccupancyData>('personCount'),
    sortBy<OccupancyData>(({ ageCategoryId }) => ageCategoryId)
);
